import { defineConfig as ie } from "tinacms";
const a = [
  {
    type: "string",
    label: "Title",
    name: "title"
  },
  {
    type: "string",
    label: "Description",
    name: "description"
  },
  {
    type: "string",
    label: "Canonical",
    name: "canonical"
  },
  {
    type: "string",
    label: "Keywords",
    name: "keywords"
  }
], oe = "https://assets.tina.io/", v = process.env.NEXT_PUBLIC_TINA_CLIENT_ID, t = (e) => {
  const s = oe + v;
  return !v || !e.includes(s) ? e : e.replace(new RegExp(s, "g"), "/" + ne);
}, g = {
  name: "banner",
  label: "Banner",
  ui: {
    defaultItem: {
      background: "/assets/images/nextjs-starter-banner.png",
      backgroundAlt: "banner-bg"
    }
  },
  fields: [
    {
      type: "image",
      name: "background",
      label: "Banner Background",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      type: "string",
      name: "backgroundAlt",
      label: "Background Alt"
    }
  ]
}, z = {
  name: "img",
  label: "Image",
  type: "object",
  fields: [
    {
      label: "Source",
      name: "src",
      type: "image",
      required: !0,
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text",
      name: "alt",
      type: "string"
    }
  ]
};
({
  ...z
});
const A = (e) => !e || isNaN(e) || Number(e) < 0 ? 0 : Number(e), m = {
  label: "Space",
  name: "Space",
  fields: [
    {
      label: "Height",
      name: "height",
      type: "number",
      ui: {
        parse: A,
        defaultValue: 8
      }
    },
    {
      label: "Mobile Height",
      name: "mobileHeight",
      type: "number",
      ui: {
        parse: A,
        defaultValue: 10
      }
    }
  ]
}, se = (e) => !e || isNaN(e) || Number(e) < 0 ? 0 : Number(e), re = {
  label: "Divider",
  name: "Divider",
  fields: [
    {
      label: "Height",
      name: "height",
      type: "number",
      ui: {
        parse: se,
        defaultValue: 1
      }
    }
  ]
}, D = (e) => !e || isNaN(e) || Number(e) < 0 ? 0 : e, j = (e) => !e || isNaN(e) || Number(e) < 1 ? 1 : Number(e) > 12 ? 12 : e, M = [
  {
    label: "Left",
    value: "left"
  },
  {
    label: "Center",
    value: "center"
  },
  {
    label: "Right",
    value: "right"
  }
], me = {
  label: "Col Image",
  name: "ColImage",
  fields: [
    {
      label: "Image",
      name: "src",
      type: "image"
    },
    {
      label: "Width",
      name: "width",
      type: "number",
      ui: {
        defaultValue: 200,
        parse: D
      }
    },
    {
      label: "Height",
      name: "height",
      type: "number",
      ui: {
        defaultValue: 200,
        parse: D
      }
    },
    {
      label: "Col Span",
      name: "colSpan",
      type: "number",
      ui: {
        defaultValue: 1,
        parse: j
      }
    },
    {
      label: "Position On Desktop",
      name: "desktopPosition",
      type: "string",
      options: M,
      ui: {
        defaultValue: "left"
      }
    },
    {
      label: "Position On Mobile",
      name: "mobilePosition",
      type: "string",
      options: M,
      ui: {
        defaultValue: "center"
      }
    },
    {
      label: "Alternative Text",
      name: "alt",
      type: "string"
    },
    {
      label: "Caption",
      name: "caption",
      type: "rich-text"
    }
  ]
}, pe = {
  label: "Grid Images",
  name: "GridImages",
  fields: [
    {
      label: "Col Count",
      name: "colCount",
      type: "number",
      ui: {
        defaultValue: 3,
        parse: j
      }
    },
    {
      label: "Images",
      name: "images",
      type: "rich-text",
      isBody: !0,
      templates: [
        me
      ]
    }
  ]
}, l = {
  name: "BreakLine",
  label: "Break Line",
  fields: [{
    name: "lineCount",
    label: "Line Count",
    type: "number",
    ui: { defaultValue: 1 }
  }]
}, B = {
  name: "HighLight",
  label: "High Light",
  fields: [
    {
      name: "text",
      label: "Text Content",
      type: "string"
    },
    {
      name: "backgroundColor",
      label: "Background Color: ",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "textColor",
      label: "Text Color: ",
      type: "string",
      ui: {
        component: "color"
      }
    }
  ]
}, W = {
  name: "StyledLink",
  label: "Styled Link",
  fields: [
    {
      name: "href",
      label: "Link",
      type: "string",
      description: "Start by: /",
      ui: { defaultValue: "/" }
    },
    {
      type: "string",
      label: "Label",
      name: "label"
    },
    {
      type: "string",
      name: "underline",
      label: "Underline",
      options: ["yes", "no"],
      ui: { defaultValue: "yes" }
    },
    {
      name: "textColor",
      label: "Text Color",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "lineColor",
      label: "Line Color",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "lineOffset",
      label: "Line Offset",
      type: "string",
      options: ["sm", "md", "lg", "xl"],
      ui: { defaultValue: "md" }
    },
    {
      name: "fontSize",
      label: "Font Size",
      type: "number",
      ui: { defaultValue: 16 }
    },
    {
      name: "fontWeight",
      label: "Font Weight",
      type: "string",
      options: ["light", "medium", "bold", "extraBold"],
      ui: { defaultValue: "medium" }
    }
  ]
}, O = {
  name: "StyledText",
  label: "Styled Text",
  fields: [
    {
      type: "string",
      name: "content",
      label: "Content"
    },
    {
      name: "color",
      label: "Text Color: ",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "format",
      label: "Text Format: ",
      type: "string",
      options: ["uppercase", "italic"]
    },
    {
      name: "fontSize",
      label: "Font Size: ",
      description: "unit px",
      type: "number"
    },
    {
      name: "fontWeight",
      label: "Font Weight: ",
      type: "string",
      options: ["light", "regular", "medium", "semibold", "bold", "extrabold"]
    }
  ]
}, _ = {
  name: "HighlightList",
  label: "Highlight List",
  fields: [
    {
      type: "rich-text",
      name: "listContent",
      label: "List Content",
      templates: [
        l,
        { ...W, inline: !0 },
        { ...O, inline: !0 }
      ]
    }
  ]
}, ce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Space: m,
  Divider: re,
  GridImages: pe,
  BreakLine: l,
  HighLight: B,
  StyledLink: W,
  HighLightList: _,
  StyledText: O
}, Symbol.toStringTag, { value: "Module" }));
Object.values(ce);
const C = "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", N = "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using Content here, content here, making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for lorem ipsum will uncover many web sites still in their infancy.", p = {
  name: "link",
  label: "Link",
  ui: {
    defaultItem: {
      label: "Link Label",
      href: "/"
    },
    itemProps: (e) => ({ label: e == null ? void 0 : e.label })
  },
  fields: [
    {
      name: "href",
      label: "Link",
      type: "string",
      description: "Start by: /",
      ui: { defaultValue: "/" }
    },
    {
      type: "string",
      label: "Label",
      name: "label"
    }
  ]
}, R = {
  name: "imgLink",
  label: "Image Link",
  fields: [
    z,
    ...p.fields
  ]
}, be = {
  name: "actionItem",
  label: "Action Item",
  ui: {
    defaultItem: {
      type: "button",
      href: "/",
      icon: "show"
    }
  },
  fields: [
    {
      type: "string",
      name: "type",
      label: "Type",
      options: ["button"]
    },
    {
      name: "href",
      label: "Link",
      type: "string",
      description: "Start by: /"
    },
    {
      type: "rich-text",
      label: "Label",
      name: "label"
    },
    {
      type: "string",
      name: "icon",
      label: "Icon",
      options: ["show", "hide"]
    },
    {
      type: "string",
      name: "style",
      label: "Action Style",
      ui: { defaultValue: "primary-filled" },
      options: ["transparent-border", "transparent", "primary-filled"]
    }
  ]
}, de = {
  name: "styledHeading",
  label: "Styled Heading",
  fields: [
    {
      name: "color",
      label: "Text Color: ",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "fontSize",
      label: "Font Size: ",
      description: "unit px",
      type: "number"
    },
    {
      type: "rich-text",
      name: "headingContent",
      label: "Heading Content",
      templates: [l]
    }
  ]
}, w = {
  name: "styledText",
  label: "Styled Text",
  fields: [
    {
      type: "string",
      name: "content",
      label: "Content"
    },
    {
      name: "color",
      label: "Text Color: ",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "format",
      label: "Text Format: ",
      type: "string",
      options: ["uppercase", "italic"]
    },
    {
      name: "fontSize",
      label: "Font Size: ",
      description: "unit px",
      type: "number"
    },
    {
      name: "fontWeight",
      label: "Font Weight: ",
      type: "string",
      options: ["light", "regular", "medium", "bold", "extrabold"]
    }
  ]
}, S = {
  name: "ContentBlock",
  label: "Content Block",
  fields: [
    {
      type: "rich-text",
      name: "heading",
      label: "Block Heading",
      templates: [
        l,
        { ...de },
        { ...w, inline: !0 },
        { ...B, inline: !0 }
      ]
    },
    {
      type: "rich-text",
      name: "subHeading",
      label: "Block Sub Heading"
    },
    {
      type: "rich-text",
      name: "description",
      label: "Block Description",
      templates: [
        l,
        _,
        { ...w, inline: !0 },
        { ...B, inline: !0 },
        m
      ]
    },
    {
      type: "rich-text",
      name: "actionList",
      label: "Block Action List",
      templates: [be]
    },
    {
      type: "image",
      label: "Content Background Image",
      name: "bgImgSrc",
      ui: {
        parse: (e) => t(e)
      }
    }
  ]
}, I = {
  name: "ImageSide",
  label: "Image Side Block",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "object",
      name: "size",
      label: "Media Size",
      fields: [
        {
          name: "width",
          type: "number",
          label: "Width"
        },
        {
          name: "height",
          type: "number",
          label: "Height"
        }
      ]
    },
    {
      label: "Content Placement",
      name: "contentPosition",
      type: "string",
      options: ["left", "right"],
      ui: { defaultValue: "right" }
    },
    {
      type: "rich-text",
      name: "content",
      label: "Section Content",
      isBody: !0,
      templates: [
        l,
        S
      ]
    },
    {
      name: "bgContent",
      label: "Background Color Content",
      type: "string",
      options: ["none", "white", "gray"],
      ui: {
        defaultValue: "none"
      }
    },
    {
      label: "Background",
      name: "bgSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Background",
      name: "bgAlt",
      type: "string"
    }
  ]
}, k = {
  name: "PageSection",
  label: "Page Section",
  ui: {
    defaultItem: {
      heading: C,
      content: N
    }
  },
  fields: [
    {
      type: "string",
      name: "heading",
      label: "Section Heading",
      ui: { defaultValue: C }
    },
    {
      type: "string",
      name: "content",
      label: "Section Content",
      ui: {
        component: "textarea",
        defaultValue: N
      }
    }
  ]
}, ge = {
  name: "HeroBanner",
  label: "Hero Banner",
  fields: [
    {
      type: "string",
      name: "videoBackgroundSrc",
      label: "Video Background Path",
      description: "Ex: video.mp4"
    },
    ...g.fields || [],
    {
      type: "image",
      name: "backgroundMobile",
      label: "Banner Background Mobile",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      type: "rich-text",
      name: "bannerContent",
      label: "Banner Content",
      isBody: !0,
      templates: [
        {
          name: "HeadingBlock",
          label: "Heading Block",
          fields: [
            {
              type: "string",
              name: "heading",
              label: "Banner Heading",
              ui: { defaultValue: "Banner Heading" }
            },
            {
              type: "string",
              name: "subHeading",
              label: "Banner Sub Heading",
              ui: { defaultValue: "Sub heading " }
            }
          ]
        },
        {
          name: "TitleBlock",
          label: "Title Block",
          fields: [
            {
              type: "string",
              name: "title",
              label: "Banner Title",
              ui: { defaultValue: "Banner title" }
            },
            {
              type: "string",
              name: "description",
              label: "Banner Description",
              ui: { defaultValue: "Banner description" }
            }
          ]
        },
        {
          name: "CTA",
          label: "CTA",
          fields: [
            {
              type: "string",
              name: "type",
              label: "CTA Type",
              ui: { defaultValue: "button" },
              options: ["button"]
            },
            ...p.fields
          ]
        }
      ]
    }
  ]
}, i = {
  name: "ImageHeroBanner",
  label: "Image Background Hero Banner",
  fields: [
    ...g.fields || [],
    {
      label: "Mobile Source",
      description: "If you want to change image on mobile screen, please provide image path. Default, the image for desktop screen will be used",
      name: "mobileSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      type: "rich-text",
      name: "bannerContent",
      label: "Banner Content",
      isBody: !0,
      templates: [
        {
          name: "TitleBlock",
          label: "Title Block",
          fields: [
            {
              type: "string",
              name: "title",
              label: "Banner Title",
              ui: { defaultValue: "Banner title" }
            },
            {
              type: "string",
              name: "description",
              label: "Banner Description",
              ui: { defaultValue: "Banner description" }
            },
            {
              type: "string",
              name: "descriptionType",
              label: "Description Type",
              options: ["small", "normal"],
              ui: {
                defaultValue: "normal"
              }
            }
          ]
        },
        {
          name: "RichTextTitleBlock",
          label: "Rich Text Title Block",
          fields: [
            {
              type: "rich-text",
              name: "title",
              label: "Banner Title"
            },
            {
              type: "string",
              name: "description",
              label: "Banner Description",
              ui: { defaultValue: "Banner description" }
            }
          ]
        },
        {
          name: "CTA",
          label: "CTA",
          fields: [
            {
              type: "string",
              name: "type",
              label: "CTA Type",
              ui: { defaultValue: "button" },
              options: ["button"]
            },
            ...p.fields
          ]
        }
      ]
    },
    {
      name: "hAlign",
      label: "Content Position By Horizontal: ",
      type: "string",
      options: ["left", "center", "dynamicCenter", "right"],
      ui: { defaultValue: "center" }
    },
    {
      name: "vAlign",
      label: "Content Position By Vertical: ",
      type: "string",
      options: ["top", "dynamicTop", "center", "bottom"],
      ui: { defaultValue: "center" }
    },
    {
      name: "size",
      label: "Media Size: ",
      type: "string",
      options: ["small", "medium", "large", "dynamicLarge", "extraLarge"],
      ui: { defaultValue: "large" }
    },
    {
      name: "mobileSize",
      label: "Mobile Media Size: ",
      type: "string",
      options: ["small-300", "small", "medium", "large", "extraLarge"],
      ui: { defaultValue: "large" }
    },
    {
      name: "opacity",
      label: "Backdrop opacity: ",
      type: "number"
    },
    {
      name: "backdropColor",
      label: "Backdrop Color: ",
      type: "string",
      ui: {
        component: "color"
      }
    },
    {
      name: "bannerQuality",
      label: "Banner Quality",
      type: "number",
      description: "Quality of banner. Min is 75% and Max is 100%",
      ui: {
        parse: (e) => !e || isNaN(e) || Number(e) < 0 ? 1 : Number(e) > 100 ? 100 : Number(e)
      }
    }
  ]
}, ue = (e) => Object.assign({}, e), ye = {
  ...g,
  name: "FooterBanner",
  label: "Footer Banner",
  fields: [
    ...g.fields || [],
    {
      type: "rich-text",
      name: "bannerContent",
      label: "Banner Content",
      templates: [
        {
          ...ue(p),
          inline: !0
        }
      ]
    }
  ]
}, V = (e) => !e || isNaN(e) || e < 1 ? 1 : e;
[
  ...k.fields
];
const fe = () => Object.assign({}, p), he = {
  name: "HomeSectionIntro",
  label: "Home Intro",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "rich-text",
      name: "content",
      label: "Section Content",
      isBody: !0,
      templates: [
        {
          name: "ContentBlock",
          label: "Content Block",
          fields: [
            {
              type: "string",
              name: "heading",
              label: "Section Heading",
              ui: { defaultValue: "heading" }
            },
            {
              type: "string",
              name: "title",
              label: "Banner Title",
              ui: { defaultValue: "Banner title" }
            },
            {
              type: "rich-text",
              name: "description",
              label: "Banner Description",
              templates: [l]
            }
          ]
        }
      ]
    },
    {
      name: "actionList",
      label: "Action List",
      type: "object",
      list: !0,
      ui: {
        defaultItem: {
          type: "button",
          label: "action label",
          link: "/",
          icon: "show"
        },
        itemProps: (e) => ({ label: e == null ? void 0 : e.label })
      },
      fields: [
        {
          type: "string",
          name: "type",
          label: "Type",
          options: ["button"]
        },
        ...fe().fields,
        {
          type: "string",
          name: "icon",
          label: "Icon",
          options: ["show", "hide"]
        }
      ]
    }
  ]
}, Be = {
  name: "HomeSectionAbout",
  label: "Home About",
  fields: [
    {
      label: "Background",
      name: "background",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      type: "rich-text",
      name: "body",
      label: "Section Body",
      description: "Use embeded template for add content block",
      isBody: !0,
      templates: [
        I,
        S
      ]
    }
  ]
}, Ce = {
  label: "Service Item",
  name: "serviceItem",
  fields: [
    {
      label: "Image",
      name: "src",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Title",
      name: "title",
      type: "string"
    },
    {
      label: "Link",
      name: "href",
      type: "string"
    }
  ]
}, Se = {
  name: "HomeSectionServices",
  label: "Home Services",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "string"
    },
    {
      label: "Service List",
      name: "serviceList",
      type: "rich-text",
      templates: [
        Ce
      ]
    },
    {
      label: "Action",
      name: "action",
      type: "object",
      fields: [
        {
          label: "Label",
          name: "label",
          type: "string"
        },
        {
          label: "Link",
          name: "href",
          type: "string"
        }
      ]
    }
  ]
}, Ie = {
  label: "Review Item",
  name: "ReivewItem",
  ui: {
    defaultItem: {
      rate: "5"
    }
  },
  fields: [
    {
      label: "Avatar",
      name: "avatar",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Content",
      name: "content",
      type: "rich-text"
    },
    {
      label: "Reviewer",
      name: "reviewer",
      type: "string"
    },
    {
      label: "Rate",
      name: "rate",
      type: "string",
      options: ["1", "2", "3", "4", "5"]
    }
  ]
}, ke = {
  label: "Home Section Testimonials",
  name: "HomeSectionTestimonials",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "string"
    },
    {
      label: "Image",
      name: "src",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Image Alt",
      name: "alt",
      type: "string"
    },
    {
      label: "Review List",
      name: "reviewList",
      type: "rich-text",
      templates: [
        Ie
      ]
    }
  ]
}, xe = {
  label: "Image Item",
  name: "ImageItem",
  fields: [
    {
      label: "Image",
      name: "src",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Image Alt",
      name: "alt",
      type: "string"
    }
  ]
}, Le = {
  label: "Home Section Tour",
  name: "HomeSectionTour",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "string"
    },
    {
      label: "Image List",
      name: "imageList",
      type: "rich-text",
      templates: [
        xe
      ]
    }
  ]
};
[
  ...k.fields
];
const Te = {
  name: "FormConfig",
  label: "Form Config",
  fields: [
    {
      label: "Email Subject",
      name: "emailSubject",
      type: "string"
    },
    {
      label: "Email To",
      name: "emailTo",
      type: "string",
      description: "If you do not provide this value, Form data will be sent to email which was configured in code"
    }
  ]
}, He = {
  label: "Input Title",
  name: "inputTitle",
  type: "object",
  ui: {
    defaultItem: {
      name: "Name",
      email: "Email",
      phone: "Phone",
      preferredDate: "Preferred Date",
      preferredTime: "Preferred Time",
      dentalInsuranceName: "Dental Insurance Name",
      dentalInsuranceId: "Dental Insurance ID",
      dateOfBirth: "Date of Birth",
      message: "How may we help?"
    }
  },
  fields: [
    {
      label: "Name",
      name: "name",
      type: "string"
    },
    {
      label: "Email",
      name: "email",
      type: "string"
    },
    {
      label: "Phone",
      name: "phone",
      type: "string"
    },
    {
      label: "Preferred Date",
      name: "preferredDate",
      type: "string"
    },
    {
      label: "Preferred Time",
      name: "preferredTime",
      type: "string"
    },
    {
      label: "Dental Insurance Name",
      name: "dentalInsuranceName",
      type: "string"
    },
    {
      label: "Dental Insurance ID",
      name: "dentalInsuranceId",
      type: "string"
    },
    {
      label: "Date of Birth",
      name: "dateOfBirth",
      type: "string"
    },
    {
      label: "Message",
      name: "message",
      type: "string"
    }
  ]
}, Pe = {
  label: "Input Error Messages",
  name: "inputErrorMessages",
  type: "object",
  ui: {
    defaultItem: {
      nameEmpty: "Name is required",
      nameInvalid: "Name is invalid",
      nameMaxLength: "Max length of name is 30",
      emailEmpty: "Email is required",
      emailInvalid: "Email is invalid",
      phoneEmpty: "Phone is required",
      phoneInvalid: "Phone is invalid",
      messageEmpty: "Message is required",
      messageMaxLength: "Max length of message is 250",
      messageInvalid: "Message is invalid",
      invalid: "This field is invalid",
      maxLength: "Max length of this field is"
    }
  },
  fields: [
    {
      label: "Name is empty",
      name: "nameEmpty",
      type: "string"
    },
    {
      label: "Name is invalid",
      name: "nameInvalid",
      type: "string"
    },
    {
      label: "Name is max length",
      name: "nameMaxLength",
      type: "string"
    },
    {
      label: "Email is empty",
      name: "emailEmpty",
      type: "string"
    },
    {
      label: "Email is invalid",
      name: "emailInvalid",
      type: "string"
    },
    {
      label: "Phone is empty",
      name: "phoneEmpty",
      type: "string"
    },
    {
      label: "Phone is invalid",
      name: "phoneInvalid",
      type: "string"
    },
    {
      label: "Message is empty",
      name: "messageEmpty",
      type: "string"
    },
    {
      label: "Message is max length",
      name: "messageMaxLength",
      type: "string"
    },
    {
      label: "Message is invalid",
      name: "messageInvalid",
      type: "string"
    },
    {
      label: "Field is invalid",
      name: "invalid",
      type: "string"
    },
    {
      label: "Field is max length",
      name: "maxLength",
      type: "string"
    }
  ]
}, ve = {
  label: "Submit Result",
  name: "submitResult",
  type: "object",
  ui: {
    defaultItem: {
      successTitle: "Success",
      successDescription: "Your request have been submitted!",
      failedTitle: "Failed",
      failedDescription: "Submit your request is failed, please try again",
      confirmTitle: "OK"
    }
  },
  fields: [
    {
      label: "Success Title",
      name: "successTitle",
      type: "string"
    },
    {
      label: "Success Description",
      name: "successDescription",
      type: "string"
    },
    {
      label: "Failed Title",
      name: "failedTitle",
      type: "string"
    },
    {
      label: "Failed Description",
      name: "failedDescription",
      type: "string"
    },
    {
      label: "Confirm Title",
      name: "confirmTitle",
      type: "string"
    }
  ]
}, Ae = {
  name: "ContactByEmail",
  label: "Contact By Email Section",
  fields: [
    {
      label: "Page Heading",
      name: "pageHeading",
      type: "string"
    },
    {
      label: "Page Description",
      name: "pageDescription",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      type: "string",
      name: "heading",
      label: "Section Heading",
      ui: { defaultValue: C }
    },
    He,
    Pe,
    ve,
    {
      label: "Form Description",
      name: "formDescription",
      type: "string",
      ui: {
        defaultValue: "Please do not send health information via this form.",
        component: "textarea"
      }
    },
    {
      label: "Submit Form Title",
      name: "submitFormTitle",
      type: "string",
      ui: {
        defaultValue: "SEND"
      }
    },
    ...Te.fields
  ]
}, De = {
  name: "Image",
  label: "Image",
  fields: [
    {
      label: "Source",
      name: "src",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text",
      name: "alt",
      type: "string"
    }
  ]
}, Me = {
  name: "AboutUsSectionBody",
  label: "About Us Body",
  fields: [
    {
      name: "imagesBlock",
      label: "Images Block",
      type: "rich-text",
      templates: [De]
    },
    {
      type: "rich-text",
      name: "contentBlock",
      label: "Content Block",
      templates: [l]
    }
  ]
}, Ne = {
  name: "EducationItem",
  label: "Education Item",
  fields: [
    {
      name: "imageSrc",
      label: "Image",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "object",
      name: "size",
      label: "Media Size",
      ui: {
        defaultItem: {
          width: 256,
          height: 182
        }
      },
      fields: [
        {
          name: "width",
          type: "number",
          label: "Width"
        },
        {
          name: "height",
          type: "number",
          label: "Height"
        }
      ]
    }
  ]
}, we = {
  name: "MeetDoctorAbout",
  label: "Meet Doctor Section About",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "object",
      name: "size",
      label: "Media Size",
      fields: [
        {
          name: "width",
          type: "number",
          label: "Width"
        },
        {
          name: "height",
          type: "number",
          label: "Height"
        }
      ]
    },
    {
      label: "Content Placement",
      name: "contentPosition",
      type: "string",
      options: ["left", "right"],
      ui: { defaultValue: "right" }
    },
    {
      type: "rich-text",
      name: "content",
      label: "Section Content",
      isBody: !0,
      templates: [
        l
      ]
    },
    {
      name: "degree",
      label: "Dental Degree",
      type: "string"
    },
    {
      name: "availableDay",
      label: "Available Day",
      type: "string"
    },
    {
      name: "bgContent",
      label: "Background Color Content",
      type: "string",
      options: ["none", "white", "gray"],
      ui: {
        defaultValue: "none"
      }
    },
    {
      type: "rich-text",
      name: "description",
      label: "Section Description",
      isBody: !0,
      templates: [
        l
      ]
    },
    {
      label: "Background",
      name: "bgSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Background",
      name: "bgAlt",
      type: "string"
    },
    {
      name: "sectionEducationLabel",
      label: "Section Education Label",
      type: "string"
    },
    {
      name: "sectionEducation",
      label: "Section Education",
      type: "rich-text",
      templates: [
        Ne
      ]
    }
  ]
}, Ve = {
  name: "OurTeamItem",
  label: "Our Team Item",
  fields: [
    {
      name: "imageSrc",
      type: "image",
      label: "Image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "object",
      name: "size",
      label: "Media Size",
      fields: [
        {
          name: "width",
          type: "number",
          label: "Width"
        },
        {
          name: "height",
          type: "number",
          label: "Height"
        }
      ]
    },
    {
      label: "Content Placement",
      name: "contentPosition",
      type: "string",
      options: ["left", "right"],
      ui: { defaultValue: "right" }
    },
    {
      name: "name",
      label: "Doctor name",
      type: "string"
    },
    {
      name: "position",
      label: "Position",
      type: "string"
    },
    {
      type: "rich-text",
      name: "content",
      label: "Section Content",
      isBody: !0,
      templates: [l]
    }
  ]
}, Fe = {
  name: "MeetDoctorSectionOurTeam",
  label: "Meet Doctor Section Our Team",
  fields: [
    {
      name: "heading",
      label: "Heading",
      type: "string"
    },
    {
      name: "ourTeamList",
      label: "Our Team List",
      type: "rich-text",
      templates: [Ve]
    }
  ]
}, x = (e, s) => {
  let d = Object.assign({}, e);
  if (d && (s == null ? void 0 : s.length)) {
    let ae = d.fields.filter((le) => !s.includes(le.name));
    d.fields = ae;
  }
  return d;
}, Ee = {
  label: "Service Block",
  name: "ServiceBlock",
  fields: [
    ...x(S, ["bgImgSrc", "subHeading", "actionList"]).fields,
    {
      label: "Description Min Height",
      name: "descriptionMinHeight",
      type: "string",
      options: ["150", "180"]
    },
    {
      label: "Image",
      name: "src",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    ...p.fields
  ]
}, ze = {
  label: "Service List Section",
  name: "ServiceListSection",
  fields: [
    {
      label: "Body",
      name: "body",
      type: "rich-text",
      templates: [
        Ee
      ]
    }
  ]
}, o = [
  "unset",
  "375",
  "409",
  "450",
  "490",
  "510",
  "530",
  "589",
  "674",
  "700",
  "740",
  "768",
  "850",
  "1165"
], c = [
  "justify_none",
  "justify",
  "center",
  "center_justify"
], je = [
  "0%",
  "10%",
  "20%",
  "25%",
  "27%",
  "50%",
  "65%",
  "80%"
], We = [
  "489",
  "674",
  "716"
], U = [
  "full"
], G = [
  "purple",
  "white"
], b = [
  "black10",
  "white",
  "greyF7"
], $ = [
  "higher",
  "lower"
], u = [
  "334_267",
  "509_473",
  "580_350",
  "600_400"
], y = [
  "bottom_left",
  "bottom_right",
  "top_left",
  "top_right"
], f = [
  "25"
], h = [
  "5",
  "10"
], Y = [
  "l-25",
  "l-38"
], n = (e) => !e || isNaN(e) || Number(e) < 0 ? 0 : Number(e), Oe = {
  label: "Padding",
  name: "padding",
  type: "object",
  fields: [
    {
      label: "Padding Top",
      name: "paddingTop",
      type: "number",
      ui: {
        parse: n,
        defaultValue: 100
      }
    },
    {
      label: "Padding Top Mobile",
      name: "paddingTopMobile",
      type: "number",
      ui: {
        parse: n,
        defaultValue: 100
      }
    },
    {
      label: "Padding Bottom",
      name: "paddingBottom",
      type: "number",
      ui: {
        parse: n,
        defaultValue: 100
      }
    },
    {
      label: "Padding Bottom Mobile",
      name: "paddingBottomMobile",
      type: "number",
      ui: {
        parse: n,
        defaultValue: 100
      }
    }
  ]
}, L = {
  label: "Heading Block",
  name: "HeadingBlock",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "rich-text"
    },
    {
      label: "Heading Max Width",
      name: "headingMaxWidth",
      type: "string",
      options: o
    },
    {
      label: "Heading Align",
      name: "headingAlign",
      type: "string",
      options: c
    },
    {
      label: "Heading Color",
      name: "headingColor",
      type: "string",
      options: b
    }
  ]
}, _e = {
  label: "Tick Heading Block",
  name: "TickHeadingBlock",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "string"
    }
  ]
}, T = {
  label: "Content Block",
  name: "ContentBlock",
  fields: [
    {
      label: "Description",
      name: "description",
      type: "rich-text"
    },
    {
      label: "Description Max Width",
      name: "descriptionMaxWidth",
      type: "string",
      options: o
    },
    {
      label: "Description Align",
      name: "descriptionAlign",
      type: "string",
      options: c
    },
    {
      label: "Description Color",
      name: "descriptionColor",
      type: "string",
      options: b
    },
    {
      label: "Padding",
      name: "padding",
      type: "string",
      options: Y
    }
  ]
}, Re = {
  label: "Check Block",
  name: "CheckBlock",
  fields: [
    {
      label: "Content List",
      name: "contentList",
      type: "string",
      list: !0
    }
  ]
}, q = {
  label: "Content List Block",
  name: "ContentListBlock",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "string",
      list: !0
    },
    {
      label: "Max Width",
      name: "maxWidth",
      type: "string",
      options: o
    },
    {
      label: "Line Height",
      name: "lineHeight",
      type: "string",
      options: f
    },
    {
      label: "Gap Y",
      name: "gapY",
      type: "string",
      options: h
    },
    {
      label: "Normal Style",
      name: "normalStyle",
      type: "string"
    }
  ]
}, X = {
  label: "Content List Block Normal",
  name: "ContentListBlockNormal",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "string",
      list: !0
    },
    {
      label: "Max Width",
      name: "maxWidth",
      type: "string",
      options: o
    },
    {
      label: "Line Height",
      name: "lineHeight",
      type: "string",
      options: f
    },
    {
      label: "Gap Y",
      name: "gapY",
      type: "string",
      options: h
    }
  ]
}, Ue = {
  label: "Color Content Item",
  name: "ColorContentItem",
  fields: [
    {
      label: "Size",
      name: "size",
      type: "string",
      options: ["size1", "size2", "size3"]
    },
    {
      label: "Heading",
      name: "heading",
      type: "string"
    },
    {
      label: "Content",
      name: "content",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      label: "Content Align",
      name: "contentAlign",
      type: "string",
      options: c
    }
  ]
}, Ge = {
  label: "Color Content Block",
  name: "ColorContentBlock",
  fields: [
    {
      label: "Color Content List",
      name: "colorContentList",
      type: "rich-text",
      templates: [
        Ue
      ]
    },
    {
      label: "Max Width",
      name: "maxWidth",
      type: "string",
      options: o
    }
  ]
}, K = {
  label: "Line",
  name: "Line",
  fields: [
    {
      label: "Max width",
      name: "maxWidth",
      type: "string",
      options: U
    },
    {
      label: "Line Color",
      name: "lineColor",
      type: "string",
      options: G
    }
  ]
}, $e = () => {
  let e = x(I, ["content", "bgContent", "bgSrc", "bgAlt"]);
  return e.fields = [
    ...e.fields,
    {
      label: "Content",
      name: "content",
      type: "rich-text",
      templates: [L, T, q, K, m, X]
    },
    {
      label: "Padding X Content",
      name: "paddingXContent",
      type: "object",
      fields: [
        {
          label: "Left",
          name: "left",
          type: "number",
          ui: {
            parse: n
          }
        },
        {
          label: "Right",
          name: "right",
          type: "number",
          ui: {
            parse: n
          }
        }
      ]
    },
    {
      label: "Gap x",
      name: "gapX",
      type: "number",
      ui: {
        parse: n
      }
    },
    {
      label: "Image Position",
      name: "imagePosition",
      type: "string",
      options: $
    },
    {
      label: "Background Color Content",
      name: "backgroundColorContent",
      type: "string",
      options: b
    },
    {
      label: "Decor Size",
      name: "decorSize",
      type: "string",
      options: u
    },
    {
      label: "Decor Postion",
      name: "decorPosition",
      type: "string",
      options: y
    }
  ], e;
}, Ye = {
  label: "Multi Image Item",
  name: "MultiImageItem",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "object",
      name: "size",
      label: "Media Size",
      fields: [
        {
          name: "width",
          type: "number",
          label: "Width"
        },
        {
          name: "height",
          type: "number",
          label: "Height"
        }
      ]
    },
    {
      label: "Decor Size",
      name: "decorSize",
      type: "string",
      options: u
    },
    {
      label: "Decor Postion",
      name: "decorPosition",
      type: "string",
      options: y
    }
  ]
}, qe = {
  label: "Multi Images Side",
  name: "MultiImagesSide",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "rich-text",
      templates: [L, _e, T, q, m, K, X]
    },
    {
      label: "Multi Image List",
      name: "multiImageList",
      type: "rich-text",
      templates: [
        Ye
      ]
    },
    {
      label: "Gap x",
      name: "gapX",
      type: "number",
      ui: {
        parse: n
      }
    }
  ]
}, Xe = {
  label: "Service Detail Section Content",
  name: "ServiceDetailSectionContent",
  fields: [
    {
      label: "Section Postion",
      name: "sectionPosition",
      type: "string",
      options: ["absolute"]
    },
    {
      label: "Section Height",
      name: "sectionHeight",
      type: "string",
      options: We
    },
    {
      label: "Body",
      name: "body",
      type: "rich-text",
      templates: [
        L,
        T,
        Re,
        Ge,
        $e(),
        qe,
        m
      ]
    },
    {
      label: "Intro Content",
      name: "introContent",
      type: "string"
    },
    {
      label: "Background",
      name: "backgroundSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Mobile Background",
      name: "mobileBackgroundSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      name: "mobileImageObjectPosition",
      label: "Mobile Image Object Position",
      type: "string",
      description: "Change Mobile Image Position To Make Banner Looks Like Design",
      options: je
    },
    Oe
  ]
}, Ke = {
  name: "ServiceDetailSectionSingleImageContent",
  label: "Service Detail Section Single Image Content",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Content",
      name: "content",
      type: "rich-text"
    }
  ]
}, H = {
  label: "Heading Block",
  name: "HeadingBlock",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "rich-text"
    },
    {
      label: "Heading Max Width",
      name: "headingMaxWidth",
      type: "string",
      options: o
    },
    {
      label: "Heading Align",
      name: "headingAlign",
      type: "string",
      options: c
    },
    {
      label: "Heading Color",
      name: "headingColor",
      type: "string",
      options: b
    }
  ]
}, Qe = {
  label: "Tick Heading Block",
  name: "TickHeadingBlock",
  fields: [
    {
      label: "Heading",
      name: "heading",
      type: "string"
    }
  ]
}, P = {
  label: "Content Block",
  name: "ContentBlock",
  fields: [
    {
      label: "Description",
      name: "description",
      type: "rich-text"
    },
    {
      label: "Description Max Width",
      name: "descriptionMaxWidth",
      type: "string",
      options: o
    },
    {
      label: "Description Align",
      name: "descriptionAlign",
      type: "string",
      options: c
    },
    {
      label: "Description Color",
      name: "descriptionColor",
      type: "string",
      options: b
    },
    {
      label: "Padding",
      name: "padding",
      type: "string",
      options: Y
    }
  ]
}, Je = {
  label: "Check Block",
  name: "CheckBlock",
  fields: [
    {
      label: "Content List",
      name: "contentList",
      type: "string",
      list: !0
    }
  ]
}, Q = {
  label: "Content List Block",
  name: "ContentListBlock",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "string",
      list: !0
    },
    {
      label: "Max Width",
      name: "maxWidth",
      type: "string",
      options: o
    },
    {
      label: "Line Height",
      name: "lineHeight",
      type: "string",
      options: f
    },
    {
      label: "Gap Y",
      name: "gapY",
      type: "string",
      options: h
    }
  ]
}, J = {
  label: "Content List Block Normal",
  name: "ContentListBlockNormal",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "string",
      list: !0
    },
    {
      label: "Max Width",
      name: "maxWidth",
      type: "string",
      options: o
    },
    {
      label: "Line Height",
      name: "lineHeight",
      type: "string",
      options: f
    },
    {
      label: "Gap Y",
      name: "gapY",
      type: "string",
      options: h
    }
  ]
}, Ze = {
  label: "Color Content Item",
  name: "ColorContentItem",
  fields: [
    {
      label: "Size",
      name: "size",
      type: "string",
      options: ["size1", "size2", "size3"]
    },
    {
      label: "Heading",
      name: "heading",
      type: "string"
    },
    {
      label: "Content",
      name: "content",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      label: "Content Align",
      name: "contentAlign",
      type: "string",
      options: c
    }
  ]
}, et = {
  label: "Color Content Block",
  name: "ColorContentBlock",
  fields: [
    {
      label: "Color Content List",
      name: "colorContentList",
      type: "rich-text",
      templates: [
        Ze
      ]
    },
    {
      label: "Max Width",
      name: "maxWidth",
      type: "string",
      options: o
    }
  ]
}, Z = {
  label: "Line",
  name: "Line",
  fields: [
    {
      label: "Max width",
      name: "maxWidth",
      type: "string",
      options: U
    },
    {
      label: "Line Color",
      name: "lineColor",
      type: "string",
      options: G
    }
  ]
}, tt = () => {
  let e = x(I, ["content", "bgContent", "bgSrc", "bgAlt"]);
  return e.fields = [
    ...e.fields,
    {
      label: "Content",
      name: "content",
      type: "rich-text",
      templates: [H, P, Q, Z, m, J]
    },
    {
      label: "Padding X Content",
      name: "paddingXContent",
      type: "object",
      fields: [
        {
          label: "Left",
          name: "left",
          type: "number",
          ui: {
            parse: n
          }
        },
        {
          label: "Right",
          name: "right",
          type: "number",
          ui: {
            parse: n
          }
        }
      ]
    },
    {
      label: "Gap x",
      name: "gapX",
      type: "number",
      ui: {
        parse: n
      }
    },
    {
      label: "Image Position",
      name: "imagePosition",
      type: "string",
      options: $
    },
    {
      label: "Background Color Content",
      name: "backgroundColorContent",
      type: "string",
      options: b
    },
    {
      label: "Decor Size",
      name: "decorSize",
      type: "string",
      options: u
    },
    {
      label: "Decor Postion",
      name: "decorPosition",
      type: "string",
      options: y
    }
  ], e;
}, ee = {
  label: "Multi Image Item",
  name: "MultiImageItem",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      type: "object",
      name: "size",
      label: "Media Size",
      fields: [
        {
          name: "width",
          type: "number",
          label: "Width"
        },
        {
          name: "height",
          type: "number",
          label: "Height"
        }
      ]
    },
    {
      label: "Decor Size",
      name: "decorSize",
      type: "string",
      options: u
    },
    {
      label: "Decor Postion",
      name: "decorPosition",
      type: "string",
      options: y
    }
  ]
}, nt = {
  label: "Multi Images Side",
  name: "MultiImagesSide",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "rich-text",
      templates: [H, Qe, P, Q, m, Z, J]
    },
    {
      label: "Multi Image List",
      name: "multiImageList",
      type: "rich-text",
      templates: [
        ee
      ]
    },
    {
      label: "Gap x",
      name: "gapX",
      type: "number",
      ui: {
        parse: n
      }
    }
  ]
}, at = {
  label: "Service Detail Multi Images Side",
  name: "ServiceDetailMultiImagesSide",
  fields: [
    {
      label: "Content",
      name: "content",
      type: "rich-text",
      templates: [
        H,
        P,
        Je,
        et,
        tt(),
        nt,
        m
      ]
    },
    {
      label: "Multi Image List",
      name: "multiImageList",
      type: "rich-text",
      templates: [
        ee
      ]
    },
    {
      label: "Gap x",
      name: "gapX",
      type: "number",
      ui: {
        parse: n
      }
    }
  ]
}, lt = {
  name: "TestimonialsSectionIntro",
  label: "Testimonials Intro",
  fields: [
    {
      label: "Background",
      name: "bgSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Background",
      name: "bgAlt",
      type: "string"
    },
    {
      name: "ContentBlock",
      label: "Content Block",
      type: "rich-text",
      templates: [l]
    },
    {
      name: "reviewHeading",
      label: "Review Heading",
      type: "string"
    },
    {
      name: "reviewDescription",
      label: "Review Description",
      type: "string"
    }
  ]
}, it = {
  name: "TestimonialsSectionReviews",
  label: "Testimonials Reviews",
  fields: [
    {
      name: "reviewList",
      label: "Review List",
      type: "object",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e == null ? void 0 : e.name }),
        defaultItem: {
          name: "unknown"
        }
      },
      fields: [
        {
          name: "name",
          label: "Name",
          type: "string"
        },
        {
          label: "Image",
          name: "imageSrc",
          type: "image",
          ui: {
            parse: (e) => t(e)
          }
        },
        {
          name: "date",
          label: "Date",
          type: "datetime"
        },
        {
          name: "content",
          label: "Content",
          type: "string",
          ui: {
            component: "textarea"
          }
        },
        {
          name: "stars",
          label: "Stars",
          type: "string",
          options: ["1", "2", "3", "4", "5"],
          ui: {
            defaultValue: "5"
          }
        }
      ]
    }
  ]
}, ot = {
  name: "PatientFormList",
  label: "Patient Form Section List",
  fields: [
    {
      name: "heading",
      label: "Heading",
      type: "string"
    },
    {
      type: "object",
      name: "patientFormList",
      label: "Patient Form List",
      list: !0,
      fields: [
        {
          name: "name",
          label: "Form Name",
          type: "string"
        },
        {
          name: "href",
          label: "Form Href",
          type: "string",
          ui: {
            defaultValue: "/#"
          }
        }
      ]
    },
    {
      name: "reviewHeading",
      label: "Review Heading",
      type: "string"
    },
    {
      name: "reviewDescription",
      label: "Review Description",
      type: "string"
    }
  ]
}, st = {
  name: "NotFoundBody",
  label: "Not Found Section Body",
  fields: [
    {
      label: "Image",
      name: "imageSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Image",
      name: "imageAlt",
      type: "string"
    },
    {
      label: "Background",
      name: "bgSrc",
      type: "image",
      ui: {
        parse: (e) => t(e)
      }
    },
    {
      label: "Alternative Text For Background",
      name: "bgAlt",
      type: "string"
    }
  ]
}, rt = {
  label: "Home Page",
  name: "homePage",
  format: "mdx",
  path: "content/home",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [ge, he, Be, Se, ke, Le, k]
    }
  ]
}, mt = {
  label: "Contact Us",
  name: "contactUs",
  format: "mdx",
  path: "content/contact-us",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Contact Us Page Body",
      name: "body",
      isBody: !0,
      templates: [i, Ae]
    }
  ]
}, pt = {
  label: "About Us",
  name: "aboutUs",
  format: "mdx",
  ui: {
    router: () => "/about-us"
  },
  path: "content/about-us",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i, Me, ye]
    }
  ]
}, ct = {
  label: "Meet The Doctor",
  name: "meetDoctor",
  format: "mdx",
  ui: {
    router: () => "/meet-the-doctor"
  },
  path: "content/meet-the-doctor",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i, we, Fe]
    }
  ]
}, bt = {
  label: "Our Services",
  name: "ourServices",
  format: "mdx",
  path: "content/our-services",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i, ze]
    }
  ]
}, dt = {
  label: "Service Detail",
  name: "serviceDetail",
  format: "mdx",
  path: "content/service-detail",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i, Xe, Ke, at]
    }
  ]
}, gt = {
  label: "Testimonials",
  name: "testimonials",
  format: "mdx",
  ui: {
    router: () => "/testimonials"
  },
  path: "content/testimonials",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i, lt, it]
    }
  ]
}, ut = {
  label: "Patient Form",
  name: "patientForm",
  format: "mdx",
  ui: {
    router: () => "/patient-forms"
  },
  path: "content/patient-form",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i, ot]
    }
  ]
}, yt = {
  label: "Not Found",
  name: "notFound",
  format: "mdx",
  ui: {
    router: () => "/not-found"
  },
  path: "content/not-found",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [st]
    }
  ]
}, ft = {
  label: "Privacy",
  name: "privacy",
  format: "mdx",
  path: "content/privacy",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Privacy Page Body",
      name: "body",
      isBody: !0
    }
  ]
}, ht = {
  label: "New Patient Form",
  name: "newPatientForm",
  format: "mdx",
  path: "content/new-patient-form",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i]
    }
  ]
}, Bt = {
  label: "Electronic Communication",
  name: "electronicCommunication",
  format: "mdx",
  path: "content/electronic-communication",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i]
    }
  ]
}, Ct = {
  label: "ChildHealthDentalHistory",
  name: "ChildHealthDentalHistory",
  format: "mdx",
  path: "content/child-health-dental-history",
  fields: [
    ...a,
    {
      type: "rich-text",
      label: "Page Body",
      name: "body",
      isBody: !0,
      templates: [i]
    }
  ]
}, St = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  homePage: rt,
  contactUs: mt,
  aboutUs: pt,
  meetDoctor: ct,
  ourServices: bt,
  serviceDetail: dt,
  testimonials: gt,
  patientForm: ut,
  notFound: yt,
  privacy: ft,
  newPatientForm: ht,
  electronicCommunication: Bt,
  ChildHealthDentalHistory: Ct
}, Symbol.toStringTag, { value: "Module" })), r = {
  name: "weekDay",
  label: "Week Day",
  ui: {
    itemProps: (e) => ({ label: e == null ? void 0 : e.day })
  },
  fields: [
    {
      name: "day",
      label: "Week Day",
      type: "string"
    },
    {
      name: "dayLabel",
      label: "Day Label",
      type: "string"
    }
  ]
}, It = {
  ...r,
  name: "work",
  label: "Work Day",
  ui: {
    ...r.ui,
    defaultItem: {
      day: "Mon",
      start: "9AM",
      end: "5PM"
    },
    itemProps: (e) => ({ label: `${e == null ? void 0 : e.day} - WORK DAY` })
  },
  fields: [
    ...r.fields,
    {
      name: "start",
      label: "From",
      type: "string"
    },
    {
      name: "end",
      label: "To",
      type: "string"
    }
  ]
}, kt = {
  ...r,
  name: "leaveEarly",
  label: "Leave Early Day",
  ui: {
    ...r.ui,
    defaultItem: {
      day: "Mon",
      start: "9AM",
      end: "4PM"
    },
    itemProps: (e) => ({ label: `${e == null ? void 0 : e.day} - LEAVE EARLY DAY` })
  },
  fields: [
    ...r.fields,
    {
      name: "start",
      label: "From",
      type: "string"
    },
    {
      name: "end",
      label: "To",
      type: "string"
    }
  ]
}, xt = {
  name: "closed",
  label: "Closed",
  ui: {
    itemProps: (e) => ({ label: `${e == null ? void 0 : e.day} - CLOSED DAY` })
  },
  fields: [
    ...r.fields,
    {
      label: "Closed Label",
      name: "closedLabel",
      type: "string"
    }
  ]
}, Lt = {
  ...r,
  ui: {
    itemProps: (e) => ({ label: `${e == null ? void 0 : e.day} - BY BOOK APPOINTMENT` })
  },
  name: "book",
  label: "By Appointment"
}, Tt = {
  type: "object",
  label: "General Info",
  name: "generalInfo",
  fields: [
    {
      type: "string",
      label: "Brand Name",
      name: "brandName"
    },
    {
      type: "string",
      label: "Email",
      name: "email"
    },
    {
      type: "object",
      label: "Office",
      name: "office",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e == null ? void 0 : e.name })
      },
      fields: [
        {
          type: "string",
          label: "Name",
          name: "name"
        },
        {
          type: "string",
          label: "Address",
          name: "address"
        },
        {
          type: "string",
          label: "Google Map Embebed Link",
          name: "googleEmbeded"
        },
        {
          type: "string",
          label: "Phone Number",
          name: "phoneNumber"
        },
        {
          type: "string",
          label: "Fax",
          name: "fax"
        },
        {
          type: "object",
          label: "Office Hours",
          name: "officeHours",
          list: !0,
          templates: [It, kt, Lt, xt]
        }
      ]
    }
  ]
}, te = {
  type: "object",
  label: "Nav Links",
  name: "nav",
  list: !0,
  ui: {
    itemProps: (e) => ({ label: e == null ? void 0 : e.label }),
    defaultItem: {
      href: "/",
      label: "Home",
      children: [],
      disabled: !1
    }
  },
  fields: [
    {
      type: "string",
      label: "Link",
      name: "href"
    },
    {
      type: "string",
      label: "Label",
      name: "label"
    },
    {
      name: "children",
      label: "Sub Items",
      type: "object",
      list: !0,
      templates: [p]
    },
    {
      name: "disabled",
      label: "Disable",
      type: "boolean"
    },
    {
      name: "exceptionLinks",
      label: "Exception Links",
      type: "string"
    }
  ]
}, Ht = {
  ...te,
  label: "Footer Nav Links",
  name: "footerNav"
}, Pt = {
  type: "object",
  label: "Social Links",
  name: "social",
  fields: [
    {
      type: "string",
      label: "Facebook",
      name: "facebook"
    },
    {
      type: "string",
      label: "Google Map",
      name: "google"
    },
    {
      type: "string",
      label: "Yelp",
      name: "yelp"
    }
  ]
}, vt = {
  type: "object",
  name: "headerLogo",
  label: "Header Logo",
  fields: R.fields
}, At = {
  type: "object",
  name: "footerLogo",
  label: "Footer Logo",
  fields: R.fields
}, Dt = {
  name: "mobileBottom",
  label: "Mobile Bottom",
  type: "object",
  fields: [
    ...p.fields
  ]
}, Mt = {
  name: "appointmentAction",
  label: "Appointment Action",
  type: "object",
  ui: {
    defaultItem: {
      requestAppointmentLabel: "Request Appointment",
      scheduleAnAppointmentLabel: "Schedule An Appointment",
      bookNowLabel: "Book Now",
      href: "/request-an-appointment"
    }
  },
  fields: [
    {
      label: "Request Appointment Label",
      name: "requestAppointmentLabel",
      type: "string"
    },
    {
      label: "Schedule An Appointment Label",
      name: "scheduleAnAppointmentLabel",
      type: "string"
    },
    {
      label: "Book Now Label",
      name: "bookNowLabel",
      type: "string"
    },
    {
      label: "Link",
      name: "href",
      type: "string"
    }
  ]
}, Nt = {
  name: "bottomLabel",
  label: "Bottom Label",
  type: "object",
  ui: {
    defaultItem: {
      questionLabel: "Questions",
      phoneLabel: "Phone",
      socialLabel: "Follow me",
      navigationLabel: "Navigation",
      officeHoursLabel: "Office Hours"
    }
  },
  fields: [
    {
      label: "Question Label",
      name: "questionLabel",
      type: "string"
    },
    {
      label: "Phone Label",
      name: "phoneLabel",
      type: "string"
    },
    {
      label: "Social Label",
      name: "socialLabel",
      type: "string"
    },
    {
      label: "Navigation Label",
      name: "navigationLabel",
      type: "string"
    },
    {
      label: "Office Hours Label",
      name: "officeHoursLabel",
      type: "string"
    }
  ]
}, wt = {
  label: "Review Statistics Content",
  name: "reviewStatisticsContent",
  type: "rich-text"
}, Vt = {
  label: "Global",
  name: "global",
  path: "content/global",
  format: "json",
  fields: [Tt, te, Ht, Pt, vt, At, Mt, Nt, Dt, wt]
}, Ft = {
  label: "Blog Posts",
  name: "posts",
  format: "mdx",
  path: "content/posts",
  fields: [
    {
      type: "string",
      label: "Title",
      name: "title"
    },
    {
      type: "rich-text",
      label: "Blog Post Body",
      name: "body",
      isBody: !0,
      templates: [
        {
          name: "PageSection",
          label: "Page Section",
          fields: [
            {
              type: "string",
              name: "heading",
              label: "Heading"
            },
            {
              type: "string",
              name: "content",
              label: "Content",
              ui: {
                component: "textarea"
              }
            }
          ]
        }
      ]
    }
  ]
}, ne = "assets/images", Et = {
  tina: {
    publicFolder: "public",
    mediaRoot: ne
  }
};
var F, E;
const zt = (E = (F = process.env.NEXT_PUBLIC_BRANCH) != null ? F : process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF) != null ? E : "develop", Wt = ie({
  schema: {
    collections: [
      Ft,
      Vt,
      ...Object.values(St)
    ]
  },
  clientId: process.env.NEXT_PUBLIC_TINA_CLIENT_ID,
  branch: zt,
  token: process.env.NEXT_PUBLIC_TINA_TOKEN || "",
  media: Et,
  build: {
    publicFolder: "public",
    outputFolder: "admin"
  }
});
export {
  Wt as default,
  ne as mediaRootPath
};
